// extracted by mini-css-extract-plugin
module.exports = {"emptyWrap":"emptyWrap___25rqr","emptyImg":"emptyImg___3ocvp","emptyText":"emptyText___12Vpo"};